import React from 'react';
import { usePageContext } from '../contexts/page-context';

const PriceWithCurrency = ({ prices = [], className }) => {
  const {
    pageContext: { currency },
  } = usePageContext();

  const priceObj = prices.find(price => price.currency === currency) || prices[0];

  if (!priceObj) {
    return null;
  }

  return (
    <div>
      {currency === 'USD' && <span>$</span>}
      <span className={className}>{new Intl.NumberFormat().format(Number(priceObj.amount))}</span>
      {currency === 'EUR' && <span>€</span>}
    </div>
  );
};

export default PriceWithCurrency;
